import { render, staticRenderFns } from "./emptyLayout.vue?vue&type=template&id=88dfd20e&scoped=true&"
import script from "./emptyLayout.vue?vue&type=script&lang=js&"
export * from "./emptyLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88dfd20e",
  null
  
)

export default component.exports